// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import i18n from './i18n';
import router from './router';
import Router from "vue-router";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import 'vue2-animate/dist/vue2-animate.min.css';
import VModal from 'vue-js-modal';
import VueMeta from 'vue-meta';
import {library} from '@fortawesome/fontawesome-svg-core';
import {
  faBars,
  faUser,
  faHeart,
  faSearch,
  faShoppingCart,
  faSortUp,
  faTruck,
  faTicketAlt,
  faSync,
  faArrowRight,
  faArrowLeft,
  faPaperPlane,
  faCheckSquare,
  faChevronUp,
  faTimes,
  faCheck,
  faChevronLeft,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {DropdownPlugin} from 'bootstrap-vue';
import VueClipboard from 'vue-clipboard2';
import elementLocale from 'element-ui/lib/locale/lang/en';
import VueLazyload from 'vue-lazyload';
import { VLazyImagePlugin } from "v-lazy-image";

Vue.use(DropdownPlugin)
library.add(faBars)
library.add(faSearch)
library.add(faUser)
library.add(faShoppingCart)
library.add(faHeart)
library.add(faSortUp)
library.add(faTruck)
library.add(faTicketAlt)
library.add(faSync)
library.add(faArrowRight)
library.add(faArrowLeft)
library.add(faPaperPlane)
library.add(faCheckSquare)
library.add(faChevronUp)
library.add(faTimes)
library.add(faCheck)
library.add(faChevronLeft)
library.add(faChevronRight)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
import VueGtag from "vue-gtag";
// import 'lib-flexible/flexible'
import Vuex from 'vuex'
import store from "./store/";
import "./assets/icons/index"
import $ from 'jquery'

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAMWwd2lcGYgDbNHdBQvd3F60iZaidfSF0',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    language: 'en-us'
  }
})


Vue.config.productionTip = false
Vue.use(Vuex);
Vue.use(VModal);
Vue.use(ElementUI, {locale: elementLocale});
Vue.use(VueAwesomeSwiper);
Vue.use(VueMeta);
Vue.use(VueClipboard);
/* eslint-disable no-new */

// enables google tracking for myumyu
Vue.use(VueGtag, {
  config: {id: "UA-157716340-1"},
}, router);

Vue.use(VueLazyload);
Vue.use(VLazyImagePlugin);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const vm = new Vue({
  i18n,
  el: '#app',
  store,
  router,
  components: {App},
  template: '<App/>'
})

export default vm



// WEBPACK FOOTER //
// ./src/main.js